import {MediaMatcher} from '@angular/cdk/layout';
import {ChangeDetectorRef,  Component, EventEmitter,  Inject,  Input,  LOCALE_ID,  OnDestroy,  OnInit,  Output,  ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Subject} from "rxjs";
import {Project} from "../../../../../model/Project";
import {StartupService} from "../../../../service-ui/startup.service";
import {ProjectService} from "../../../../service-data/project.service";
import {Draft} from "../../../../../model/Draft";
import {Book} from "../../../../../model/Book";
import {MatDialog} from "@angular/material/dialog";
import {CreateProjectComponent} from "../dialogs/create-project/create-project.component";
import {UploadPdfComponent} from "../dialogs/upload-pdf/upload-pdf.component";
import {DraftService} from "../../../../service-data/draft.service";
import {BookService} from "../../../../service-data/book.service";
import {modernDialogConfig} from "../../../../service-ui/dialog-config";

@Component({
  selector: 'app-project-details-top-controls',
  templateUrl: './project-details-top-controls.component.html',
  styleUrls: ['./project-details-top-controls.component.css']
})
export class ProjectDetailsTopControlsComponent implements OnDestroy, OnInit {
  @ViewChild('placeHolderProjectName') placeHolderProjectName;
  @Input() project: Project;
  @Input() draft: Draft;
  @Input() book: Book;
  @Input() displayCover: boolean;
  @Input() displaySettings: boolean;
  @Input() editingDetails: string;
  @Output() displayCoverChange = new EventEmitter<boolean>();
  @Output() displaySettingsChange = new EventEmitter<boolean>();
  @Output() editingDetailsChange = new EventEmitter<string>();

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  onDestroySubject: Subject<boolean> = new Subject();

  public renameProject: boolean = false;
  editingDraftTitle: boolean = false;
  editingBookTitle: boolean = false;
  sizeWidth: 0;


  constructor(public projectService: ProjectService, public dialog: MatDialog, public changeDetectorRef: ChangeDetectorRef, public media: MediaMatcher, private draftService: DraftService, private bookService: BookService) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  onDataChange() {
    this.editingDetailsChange.emit(this.editingDetails);
    this.displaySettingsChange.emit(this.displaySettings);
    this.displayCoverChange.emit(this.displayCover);
  }

  upload() {
    console.log(`Upload PDF`);

    const dialogConfig = modernDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.data = { draft: this.draft };
    const dialogRef = this.dialog.open(UploadPdfComponent, dialogConfig);
  }
  ngOnInit() {
  }

  onSubmit() {
  }

  onResize(event: any) {
    console.log("onresize " + event);
    const w = event.target.innerWidth;
    this.sizeWidth = w;
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.onDestroySubject.next(true);
    this.onDestroySubject.unsubscribe();
  }

  isProjectNameUsed(): boolean {
    if ( !this.placeHolderProjectName || !this.placeHolderProjectName.nativeElement || !this.placeHolderProjectName.nativeElement.value ) {
      return true;
    }
    const newProjectName = this.placeHolderProjectName.nativeElement.value.trim();
    for ( const project of this.projectService.objects ) {
      if ( newProjectName === project.name ) {
        return true;
      }
    }
    return false;
  }
  saveProjectName() {
    console.log('Save Project Name' + this.placeHolderProjectName.nativeElement.value);
    this.project.name = this.placeHolderProjectName.nativeElement.value;
    // this.productService.saveProjectImmediately(this.product).then( proj => {
    //   console.log('Updated product name');
    // });
  }
  cancelProjectName() {
    this.placeHolderProjectName.nativeElement.value = this.project.name;
  }

  // Draft title inline editing
  startEditDraftTitle() {
    this.editingDraftTitle = true;
    setTimeout(() => {
      const input = document.querySelector('.toolbar-title-input') as HTMLInputElement;
      if (input) { input.focus(); input.select(); }
    });
  }

  commitDraftTitle(value: string) {
    this.editingDraftTitle = false;
    const trimmed = value.trim();
    if (trimmed && trimmed !== this.draft.title) {
      this.draft.title = trimmed;
      this.draftService.updateItem(this.draft).subscribe();
    }
  }

  cancelDraftTitle(input: HTMLInputElement) {
    input.value = this.draft.title || '';
    this.editingDraftTitle = false;
  }

  // Book title inline editing
  startEditBookTitle() {
    this.editingBookTitle = true;
    setTimeout(() => {
      const input = document.querySelector('.toolbar-title-input') as HTMLInputElement;
      if (input) { input.focus(); input.select(); }
    });
  }

  commitBookTitle(value: string) {
    this.editingBookTitle = false;
    const trimmed = value.trim();
    if (trimmed && trimmed !== this.book.title) {
      this.book.title = trimmed;
      this.bookService.updateItem(this.book).subscribe();
    }
  }

  cancelBookTitle(input: HTMLInputElement) {
    input.value = this.book.title || '';
    this.editingBookTitle = false;
  }

}
